import { render, staticRenderFns } from "./EmergencyCallDashboard.vue?vue&type=template&id=75c0c8fe&scoped=true&"
import script from "./EmergencyCallDashboard.vue?vue&type=script&lang=js&"
export * from "./EmergencyCallDashboard.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyCallDashboard.vue?vue&type=style&index=0&id=75c0c8fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c0c8fe",
  null
  
)

export default component.exports